import React from 'react'
import Banner1 from './Banner1'
import ApplyLoan from './ApplyLoan'
// import EmiCalculator from './EmiCalculator'
import LoanContent from './LoanContent'
// import Feature from '../Home/Feature'
import { useLocation } from 'react-router-dom'
import LoanTable1 from './LoanTabl1'
import ComparisionCard1 from '../ComparisionCard1'

export default function Investments() {
  const location = useLocation()
  const state = location.state;

  return (
    <main>
        <Banner1 data={state}/>
        <ApplyLoan  data={state} />
{/* <ComparisionCard1 data={state}/> */}
        <LoanTable1 data={state}/>
   
    </main>
  )
}
